import { Avatar, Box, Button, Center, Flex, FormControl, FormErrorMessage, Text, Textarea, useBreakpointValue, useToast } from "@chakra-ui/react"
import { useFormik } from "formik"
import moment from "moment"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import DashboardHeader from "../../../components/common/DashboardHeader"
import TraineeSidenav from "../../../components/trainee/courses/Sidenav"
import { IDiscussionTopic } from "../../../models/trainer-discussiontopic.model"
import { IGetDiscussion } from "../../../models/trainer-getdiscussion.model"
import trainercoursesService from "../../../services/trainer/trainercourses.service"


const EachDiscussion = () => {
    const [discussion, setDiscussion] = useState<IGetDiscussion | any>([]);
    const [topic, setTopic] = useState<IDiscussionTopic | any>([]);
    const navigate = useNavigate();
    const params = useParams();
    const course_id:any = params.course_id;
    const discussion_id:any = params.id;
    const toast = useToast();
    const show = useBreakpointValue({ base: false, md: true, lg: true });

    useEffect(() => {
        if (discussion_id)
            trainercoursesService.getDiscussionTopic(discussion_id).then(
            (res) => {
                
                setTopic(res.data)
            })
            trainercoursesService.getDiscussion(discussion_id).then(
                (res) => {
                    
                    setDiscussion(res.data);
                }
            )
        
    }, [discussion_id])

    // const formik = useFormik({
    //     validate: (values: any) => {
    //         const errors: any = {};
    //         if (!values.message) {
    //             errors.message = 'Reply field is required'
    //         }
    //         return errors;
    //     },
    //     initialValues: {
    //         message: ''
       
    //     },
    //     onSubmit: async (values) => {
    //         const replyInfo: any ={
    //             message: values.message,
    //         }
    //         
    //         try {
    //             const replyInfoRes = await trainercoursesService.replyDiscussion(replyInfo, discussion_id)
    //             if (replyInfoRes.status === 'success') {
    //                 
    //             }
    //         } catch (error:any) {
    //             toast({
    //                 title: "Discussion Reply",
    //                 description: `${error.response.data.message}`,
    //                 status: "error",
    //             })
    //         }
    //     }
    // })

    const formik = useFormik({
        validate: (values: any) => {
            const errors: any = {};
            if (!values.message) {
                errors.message = 'Description is required'
            }
            return errors;
        },
        initialValues: {
            message: '',
       
        },
        onSubmit: async (values) => {

            const newDiscussionInfo: any = {
                message: values.message,
            }
            

            try {
                // post discussion api here
                const newDiscussionResponse = await trainercoursesService.createNewDiscussion(newDiscussionInfo, discussion_id)
                
                if(newDiscussionResponse.status === 'success')
                    toast({
                        title: "Discussion",
                        description: 'Discussion replied successfully',
                        status: "success",
                    })
                    formik.resetForm();
                    trainercoursesService.getDiscussion(discussion_id).then(
                        (res) => {
                            setDiscussion(res.data);
                        }
                    )

            } catch (error:any) {
                toast({
                    title: "Discussion",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
        }
    })

    return (
        <>
            <DashboardHeader />
            <Box bg='#F9F8F8' height='100%'             pt={"1.5rem"}
            pb={"2rem"}>
                <Flex width='90%' mx='auto'      pt={["50px", "60px", "60px", "80px"]}>
                    {
                        show && (
                            <TraineeSidenav />
                        )
                    }

                    <Box   width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }} mx='auto' pb={['100px','200px']} px={["20px","70px"]} pt="30px" bg='white'>
                        <Text color='#1E1E1E' fontSize='28px' pb='30px' fontWeight='600'>Discussions</Text>
                        <Flex justifyContent='flex-start' alignItems='center' mb='30px'>
                            <Button py='13px' px='30px' mt='30px' type="submit" variant={'outline'} fontSize={11} onClick={() => navigate(`/trainee/course/${course_id}/discussions`)} colorScheme='red' size='sm'>
                                BACK
                            </Button>
                            {/* <Button py='20px' px='30px' mt="30px" onClick={() => navigate(courseRoutes.NewDiscussionLink(course_id, discussion_id))} fontSize={12} borderRadius={0} colorScheme='red' size='sm'>
                                NEW DISCUSSION
                            </Button> */}
                        </Flex>
                        <Box>
                            <Flex pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                <Box mr='20px' ml='45px'>
                                    <Center mx='auto' mb='20px' bg='#C4C4C4' width='40px' height='40px' borderRadius='20px'>
                                        <Avatar width='100%' height='100%' borderRadius='50%'  name={topic?.user?.name} src='https://bit.ly/broken-link' />
                                    </Center>
                                </Box>
                                <Box mr='45px' width='90%' >
                                    <Text fontWeight='600' color='#616161' fontSize='16px'>{topic?.title}</Text>
                                    <Text fontWeight='400' color=' #B9B9B9' mb='10px' fontSize={{ lg: '12px', md: '11px', sm: '10px', base: '10px' }}>
                                        Posted {moment(topic.created_at).fromNow()} by {topic?.user?.name} 
                                        <Text as='span' fontSize={{lg: '10px', md: '9px', sm: '8px', base: '8px'}} padding='0.2rem' bgColor='#FFF4F4' color='red' borderRadius='4px' letterSpacing={'0.5px'} marginLeft={'0.3rem'} fontWeight={'700'}>
                                            {" "}{topic.user?.category}
                                        </Text>
                                    </Text>
                                    <Text mb='10px' fontSize='14px' fontWeight='500' color=' #B9B9B9'>
                                        {topic?.description}
                                    </Text>
                                </Box>
                            </Flex>
                            
                            {
                                discussion?.map((each: any, index: any) => (
                                    <Flex key={index} pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                        <Box mr='20px' ml={['10px','45px']}>
                                            <Center mx='auto' mb='20px' bg='#C4C4C4' width='40px' height='40px' borderRadius='20px'>
                                                <Avatar width='100%' height='100%' borderRadius='50%' name={each.user?.name} src='https://bit.ly/broken-link' />
                                            </Center>
                                        </Box>
                                        <Box mr='45px' width='90%' >
                                            <Text fontWeight='400' color=' #B9B9B9' mb='10px' fontSize={{ lg: '12px', md: '11px', sm: '10px', base: '10px' }}>
                                                replied {moment(each.created_at).fromNow()} by {each.user?.name} 
                                                <Text as='span' fontSize={{lg: '10px', md: '9px', sm: '8px', base: '8px'}} padding='0.2rem' bgColor='#FFF4F4' color='red' borderRadius='4px' letterSpacing={'0.5px'} marginLeft={'0.3rem'} fontWeight={'700'}>
                                                    {" "}{each.user.category}
                                                </Text>
                                            </Text>
                                            <Text mb='10px' fontSize='14px' fontWeight='500' color=' #B9B9B9' >
                                                {each.body}
                                            </Text>
                                            {/* <HStack fontSize='12px' fontWeight='400' color='  #AEAEAE'>
                                                <FiHeart />
                                                <Text>2</Text>
                                                <Image src={comment} />
                                                <Text> reply</Text>
                                            </HStack> */}
                                        </Box>
                                    </Flex>
                                ))
                            }
                            {/* {
                                discussionReplies?.map((each:any, index:any) => ( */}
                                    {/* <Flex pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                        <Box mr='20px' ml='45px'>
                                            <Center mx='auto' mb='20px' bg='#C4C4C4' width='40px' height='40px' borderRadius='20px'>
                                                <Avatar width='100%' height='100%' borderRadius='50%' name="" src='https://bit.ly/broken-link' />
                                            </Center>
                                        </Box>
                                        <Box mr='45px' width='90%' >
                                            <Flex fontWeight='400' color=' #B9B9B9' mb='10px' fontSize='12px'>replied by <Text color="red" px='3px'>Username </Text> ||  3 hours ago</Flex>
                                            <Text mb='10px' fontSize='14px' fontWeight='500' color=' #B9B9B9' >
                                                Hello everyone, you’re welcome to this course. I’m your trainer for this course and
                                                we would be together for the next 1 month. You can introducte yourself here by...
                                            </Text>
                                            <HStack fontSize='12px' fontWeight='400' color='  #AEAEAE'>
                                                <FiHeart />
                                                <Text>2</Text>

                                            </HStack>

                                        </Box>

                                    </Flex>  */}
                                {/* ))
                            } */}
                            {/* <Flex pb='20px' mb='30px' pr='30px' py='25px' borderBottom='1px solid ' borderColor='lightgrey'>
                                <Box mr='20px' ml='45px'>
                                    <Center mx='auto' mb='20px' bg='#C4C4C4' width='40px' height='40px' borderRadius='20px'>
                                        <Image width='40px' height='40px' borderRadius='20px' src={bolaji} />
                                    </Center>
                                </Box>
                                <Box mr='45px' width='90%' >
                                    <Flex fontWeight='400' color=' #B9B9B9' mb='10px' fontSize='12px'>replied by <Text color="red" px='3px'> David Olaleye </Text> ||  3 hours ago</Flex>
                                    <Text mb='10px' fontSize='14px' fontWeight='500' color=' #B9B9B9' >
                                        Hello everyone, you’re welcome to this course. I’m your trainer for this course and
                                        we would be together for the next 1 month. You can introducte yourself here by...
                                    </Text>
                                    <HStack fontSize='12px' fontWeight='400' color='  #AEAEAE'>
                                        <FiHeart />
                                        <Text>2</Text>
                                    </HStack>

                                </Box>

                            </Flex> */}
                            <FormControl mt={6} id="message" isInvalid={(formik.errors.message && formik.touched.message) ? true : false}>
                                <Textarea
                                    p={4}
                                    bg="inputText.500"
                                    fontSize={12}
                                    height="150px"
                                    size="sm"
                                    placeholder="enter reply here..."
                                    name="message"
                                    onChange={formik.handleChange}
                                    value={formik.values.message}
                                />
                                <FormErrorMessage fontSize={12} >{formik.errors.message}</FormErrorMessage>
                            </FormControl>
                            <Flex justifyContent='flex-end'>
                                <Button py='13px' 
                                px='30px' 
                                mt='30px' 
                                type="submit" 
                                fontSize={11} 
                                borderRadius={0} 
                                colorScheme='red' 
                                size='sm' 
                                isLoading={formik.isSubmitting}
                                onClick={() => formik.handleSubmit()}
                                >
                                    REPLY
                                </Button>
                            </Flex>

                        </Box>
                    </Box>
                </Flex>
            </Box>
        </>
    )
}

export default EachDiscussion;

